import { UserOutlined } from "@ant-design/icons";
import { Translations, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { SettingsView } from "./lazy-view";

const translations: Translations = { de, en };

export const settingsViewKey = "app/settings";
export const settingsViewModule: ViewModule = {
  viewKey: settingsViewKey,
  viewEl: <SettingsView/>,
  displayNameI18nKey: "app:settingsView.title",
  menuIconEl: <UserOutlined/>,
  translations,
};
